"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";

export default function ClientProviders({ children }) {
  const pathname = usePathname();

  // Handle BFcache (Back-Forward cache) reload
  useEffect(() => {
    const handlePageShow = (event) => {
      const isBackForward =
        event.persisted ||
        (typeof performance !== "undefined" &&
          performance.getEntriesByType &&
          performance.getEntriesByType("navigation")[0]?.type === "back_forward");

      if (isBackForward) {
        window.location.reload();
      }
    };

    window.addEventListener("pageshow", handlePageShow);
    return () => {
      window.removeEventListener("pageshow", handlePageShow);
    };
  }, []);

  // Initialize AOS (Animate On Scroll) for desktop
  useEffect(() => {
    if (typeof window === "undefined") return;
    const isMobile =
      window.innerWidth <= 768 ||
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      );
    if (isMobile) return;

    const scheduleInit =
      "requestIdleCallback" in window
        ? window.requestIdleCallback
        : (cb) => setTimeout(cb, 50);

    const handle = scheduleInit(async () => {
      await import("aos/dist/aos.css");
      const mod = await import("aos");
      const AOS = mod.default;
      AOS.init({
        duration: 600,
        once: true,
        easing: "ease-out",
        disable: "mobile",
        offset: 80,
      });
    });

    return () => {
      if ("cancelIdleCallback" in window && typeof handle === "number") {
        window.cancelIdleCallback(handle);
      }
    };
  }, []);

  // Re-trigger AOS on page navigation (desktop only)
  useEffect(() => {
    if (typeof window === "undefined") return;
    const isMobile =
      window.innerWidth <= 768 ||
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      );
    if (isMobile) return;

    const t = setTimeout(() => {
      import("aos").then((mod) => {
        const AOS = mod.default;
        AOS.refresh();
      });
    }, 150);
    return () => clearTimeout(t);
  }, [pathname]);

  return <>{children}</>;
}
